import * as service from './safetyplan.service'


//FG - FOOF - Change for certification - Created this class


export default {
  data() {
    return {
      mustGetData: true,
      elementInfoForServer: {
        id: null, //future use
        locId: '',
        elementId: '',
        listOfFiles: null
      },
      arrayOfElementsFromServer: []
    }
  },
  mounted() {
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      if(!context.mustGetData && (context.locationId != data.LocationId)) {
        context.mustGetData=true;
      }
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if(context.mustGetData) {
        context.getSafetyPlanElements();
        context.mustGetData=false;
      }
    })
  },

  //FG - FOOF - TOOLTIPSTER REINITIALIZE ON RESIZE
  created() {
    this.$hydrowareCommonJS.handleTooltips("create");
  },

  destroyed() {
    this.$hydrowareCommonJS.handleTooltips("destroy");
  },

  methods: {
    getSafetyPlanElements() {
      let context = this
      loader.startLoader()
      service.getSafetyPlanElements(context.locationId).then(function (response) {

        //FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
        if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
          context.Documents = []
          return;
        }
        //FG - FOOF - After Cert - First Release Security (7) - above


        if (response && response != null) {
          context.arrayOfElementsFromServer = response;
        } else {
          context.Documents = []
        }
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        alert("EeeeRROR LOC IS: " + context.locationId)
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    UploadSafetyPlanElement(e) {
      let context = this;
      this.elementInfoForServer.id=-1; //FUTURE USE
      this.elementInfoForServer.locId=this.locationId;
      //The upload and delete buttons are named such that the integer after the underscore
      //is the element number for the file being uploaded or deleted
      //AND the string prior to the underscore is either speUploadBtn or speDeleteBtn
      var splitButtonName = e.currentTarget.name.split('_')
      var buttonName = splitButtonName[0]
      var elementNumber = splitButtonName[1];
      this.elementInfoForServer.elementId=elementNumber;
      this.elementInfoForServer.listOfFiles=[];
        this.elementInfoForServer.listOfFiles=e.target.files;
      var isUpload = buttonName == "speUploadBtn"
      var uploadFileName = null;
      if(isUpload) {
        this.elementInfoForServer.listOfFiles=e.target.files;
        uploadFileName = e.target.files[0].name;
      }
      


      /*
      var okToUploadOrDelete = this.uploadConfirmOrDeleteSafetyPlanElement(isUpload, context.arrayOfElementsFromServer[elementNumber], uploadFileName);
      if(okToUploadOrDelete) {
        loader.startLoader()
        service.HandleSafetyPlanElement(this.setupDataThatWillBeSentToServer(this.elementInfoForServer)).then(function (response) {
          context.getSafetyPlanElements()
          loader.stopLoader()
          context.$notify({
            title: 'Success',
            message: 'Safety Plan Updated',
            type: 'success'
          })
        }, 
        (error) => {
          loader.stopLoader()
          alert("ERROR AFTER UPLOAD: " + error.responseJSON.Message)
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
      } 
      */




     
     var oneElement = context.arrayOfElementsFromServer[elementNumber]
     
     var msg = "Replace Element: " + oneElement.elementName + '?';
     if(!isUpload) {
       msg = "Delete Element: " + oneElement.elementName + '?';
     }
     msg = msg + "<BR><BR> Current file: " + oneElement.origFileName;
     var opts = {message: msg}
     if(isUpload) {
       if(oneElement.origFileName == '' || oneElement.origFileName == null) {
         context.okToUploadOrDeleteSafetyPlanElement()//upload the file because there is nothing there yet
         return;
       }
       msg = msg + "<BR> New file: " + uploadFileName;
       opts = {message: msg}
       context.$hydrowareCommonJS.displayConfirmUploadPopup(context, opts, context.okToUploadOrDeleteSafetyPlanElement)
     }
     else
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.okToUploadOrDeleteSafetyPlanElement)
    },


    okToUploadOrDeleteSafetyPlanElement() {
      var context=this;
      loader.startLoader()        
        service.HandleSafetyPlanElement(this.setupDataThatWillBeSentToServer(this.elementInfoForServer)).then(function (response) {
          //FG - FOOF - After Cert - First Release Security - added conditional statement below
          //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
          if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
            return;
            
          context.getSafetyPlanElements()
          loader.stopLoader()
          context.$notify({
            title: 'Success',
            message: 'Safety Plan Updated',
            type: 'success'
          })
        }, 
        (error) => {
          loader.stopLoader()          
          //context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
    },

    DownloadSafetyPlanElement(e) {
      window.open(e, '_blank');
    },

    setupDataThatWillBeSentToServer(elementInfoForServer) {
      let context = this
      var image_arr = {}
      var image_data = new FormData() //FG - FOOF - added on Dec 12 2018 while testing for uploads
      image_arr['locId'] = elementInfoForServer.locId;
      image_arr['id'] = elementInfoForServer.id;
      image_arr['elementId'] = elementInfoForServer.elementId;
      
      for (var key in image_arr) {
        image_data.append(key, image_arr[key])
      }
      if(elementInfoForServer.listOfFiles != null && elementInfoForServer.listOfFiles.length > 0) {
        for(var foofidx=0; foofidx<elementInfoForServer.listOfFiles.length; foofidx++) {
          image_data.append('listOfFiles[' + foofidx + ']', elementInfoForServer.listOfFiles[foofidx])
        }
      }
      return image_data
  },



    //When the upload button is clicked we set its value
    //to null.  This will force the Upload
    SetUploadValueToNull(e) {
      e.toElement.value=null;
    },

    uploadConfirmOrDeleteSafetyPlanElement(isUpload, oneElement, uploadFileName) {
      if(oneElement.origFileName == '' || oneElement.origFileName == null)
        return true;
      var msg = "Replace Safety Plan Element: " + oneElement.elementName;
      if(!isUpload) {
        msg = "Delete Safety Plan Element: " + oneElement.elementName 
      }
      msg = msg + "\n current file: " + oneElement.origFileName;
      if(isUpload) 
        msg = msg + "\n with file: " + uploadFileName;

      return confirm(msg)
    }
  },
  deleteCertificate(item) { alert("DELETE CERTIFICATE ?")
    let context = this
    var opts = {message: 'Are you sure you want to delete ' + item.CertificateAgencyName +'?'}
    context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.callOnServiceToDelete.bind(null,item))
  },

}



// WEBPACK FOOTER //
// ./src/pages/Compliance/safetyplan.controller.js